import { useTranslation as i18NextHook } from 'react-i18next'
import { getUserData } from 'src/HOCs/withAuth'
import { KEYSEP, NSSEP } from 'src/utils/translations'
import { getCurrentOrganizationId } from 'src/utils/permissions'

function _t(t, componentName) {
    return function (k = '', options) {
        const userData = getUserData()
        const organizationId = getCurrentOrganizationId(userData)
        const hasNamespace = String(k).includes(NSSEP)
        let namespace = null
        let baseKey

        if (hasNamespace) {
            ;[namespace, baseKey] = String(k).split(NSSEP)
        } else {
            baseKey = String(k)
        }

        let keys = [
            `${organizationId}${KEYSEP}${componentName}${KEYSEP}${baseKey}`,
            `${componentName}${KEYSEP}${baseKey}`,
            `${organizationId}${KEYSEP}${baseKey}`,
            baseKey,
        ]

        if (hasNamespace) {
            keys = keys.map(key => `${namespace}${NSSEP}${key}`)
        }

        const translation = t(keys, options)
        if (process.env.NODE_ENV !== 'development') {
            if (translation?.endsWith('_TODO')) {
                return options?.defaultValue ?? k
            }
        }

        return translation
    }
}

export default function useProjectTranslations(namespace = '', componentName) {
    const { t, i18n, ready } = i18NextHook(namespace)
    return {
        t: _t(t, componentName),
        i18n,
        ready,
    }
}
